module.exports = __webpack_public_path__ + "static/img/card-bag-bg.46d437b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/withdraw/card-bag-bg.png
// module id = BeUR
// module chunks = 215